import React from "react";
import { Alert, Box, Stack, Typography } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";
import AdminTemplatesSection from "./AdminTemplatesSection";
import AdminSponsoredCampaignsSection from "./AdminSponsoredCampaignsSection";
import AdminUsageOverviewSection from "./AdminUsageOverviewSection";
import "../Invitations/Invitations.css";
import "./AdminDashboard.css";

function AdminDashboard() {
  const { authPayload } = useAuth();

  if (authPayload?.role !== "admin") {
    return (
      <Box className="invitation-page-container">
        <Alert severity="error">
          Немате дозвола за пристап до Админ Панел.
        </Alert>
      </Box>
    );
  }

  return (
    <Box className="invitation-page-container admin-page-container">
      <Stack spacing={2} className="invitation-header" alignItems="center">
        <Typography variant="h4" component="h1">
          Админ Панел
        </Typography>
        <Typography variant="body1" color="text.secondary" textAlign="center">
          Детален увид во користењето, корисниците и содржината на платформата.
        </Typography>
      </Stack>

      <Stack spacing={2.5} className="admin-sections-wrap">
        <AdminUsageOverviewSection />
        <AdminTemplatesSection />
        <AdminSponsoredCampaignsSection />
      </Stack>
    </Box>
  );
}

export default AdminDashboard;
